<template>
  <section class="issue-certificate">
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <form-header :title="'Emitir atestado'" />
    <div class="container-sarah">
      <form-steps :steps="steps" :current-step="currentStep" />
      <div class="form-template general-forms" v-if="!statePage">
        <form-select
          :data="optionData"
          :label="label"
          v-model="option.value"
          @change-data="checkSelectedOption($event)"
          v-if="diapersActiveComponent != 'DiapersSize'"
        />
        <date-select
          ref="DateSelect"
          :dates="datesExamAttendance"
          v-if="finalidadeSelecionada === TiposAtestados.Comparecimento"
          :warning-text="avisoComparecimento"
        />
        <date-select
          ref="DateSelect"
          :dates="datesExamHospitalization"
          v-if="finalidadeSelecionada === TiposAtestados.Internacao"
          :warning-text="warningTextHosp"
        />
        <cdi-option
          v-if="finalidadeSelecionada === TiposAtestados.CadeiraRodas"
          v-model="descricao"
        />
        <div v-if="finalidadeSelecionada === TiposAtestados.Fraldas">
          <keep-alive>
            <component :is="diapersActiveComponent" v-model="descricao" />
          </keep-alive>
        </div>
        <cdi-option
          v-if="finalidadeSelecionada === TiposAtestados.Acessibilidade"
          v-model="descricao"
        />
        <DeclaracaoAtendimento
          v-if="finalidadeSelecionada === TiposAtestados.Declaracao"
        />
      </div>
      <state-response
        v-if="statePage"
        :state-title="stateTitle"
        :state-text="stateText"
        :button-text="buttonText"
        :status-ok="statusOk"
        @click-button="openDocs"
      />
      <form-footer
        @go-to="chooseSelected"
        :disabled="getButtonDisabled"
        :final-page="statePage"
        :ok-page="statusOk"
        :mult-comp="multipleComp"
        @next-step="diapersActiveComponent = 'DiapersSize'"
        @prev-step="diapersActiveComponent = 'DiapersOption'"
        :last-comp="lastComp"
      />
    </div>
  </section>
</template>

<script>
import FormHeader from '@/components/shared/header/FormHeader'
import FormFooter from '@/components/atestados/FormFooter'
import FormSteps from '@/components/shared/forms/FormSteps'
import FormSelect from '@/components/atestados/FormSelect'
import StateResponse from '@/components/atestados/StateResponse'
import DateSelect from '@/components/atestados/DateSelect'
import CdiOption from '@/components/atestados/CdiOption'
import DiapersOption from '@/components/atestados/DiapersOption'
import DiapersSize from '@/components/atestados/DiapersSize'
import DeclaracaoAtendimento from '@/components/atestados/DeclaracaoAtendimento'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TiposDocumentos, TiposAtestados } from '../mixins/tipos-documentos'
import router from '@/router'

export default {
  name: 'Atestado',
  components: {
    FormHeader,
    FormSteps,
    FormSelect,
    FormFooter,
    StateResponse,
    CdiOption,
    DateSelect,
    DiapersOption,
    DiapersSize,
    DeclaracaoAtendimento
  },

  data() {
    return {
      stateTitle: '',
      stateText: '',
      isFullPage: true,
      type: 2,
      statusOk: true,
      buttonText: 'Entendi',
      statePage: false,
      valueSelected: '',
      finalidadeSelecionada: null,
      currentStep: 0,
      textInput: '',
      diapersInput: '',
      descricao: '',
      diapersActiveComponent: 'DiapersOption',
      cidInput: '',
      option: { value: this.$t('placeholders.dropdown') },
      label: this.$t('documentos.escolha-finalidade'),
      commonPlaceholder: this.$t('placeholders.common'),
      dropdown: this.$t('placeholders.dropdown'),
      steps: [{ name: 'Finalidade' }, { name: 'Informações Finais' }],
      TiposAtestados: TiposAtestados
    }
  },
  created() {
    this.SET_ATESTADO_DADOS([])
    this.getAtestadoFinalidades()
    this.getCombosAction()
    this.DESABILITAR_BOTAO_ENVIAR(true)
  },
  computed: {
    ...mapGetters({
      getFinalidades: 'getFinalidades',
      getCombosResponse: 'getCombosResponse',
      getDadosAtestado: 'getDadosAtestado',
      getDateFilter: 'getDateFilter',
      isLoading: 'isLoading',
      getRespostaAtestado: 'getRespostaAtestado',
      getPatientPrintDocs: 'getPatientPrintDocs',
      getButtonDisabled: 'getButtonDisabled'
    }),
    multipleComp() {
      return this.finalidadeSelecionada === TiposAtestados.Fraldas
    },
    lastComp() {
      let checkComp = true
      if (
        this.finalidadeSelecionada === TiposAtestados.Fraldas &&
        this.diapersActiveComponent === 'DiapersOption'
      ) {
        checkComp = false
      } else {
        checkComp = true
      }
      return checkComp
    },
    optionData: {
      get() {
        return Object.entries(this.getFinalidades).map(([key, value]) => {
          const finalidade = {
            id: parseInt(key),
            value: value
          }
          return finalidade
        })
      }
    },
    datesExamAttendance: {
      get() {
        return Object.entries(this.getCombosResponse.Comparecimentos).map(
          ([key, value]) => {
            const dateAttendance = {
              checkboxDesc: value,
              active: false
            }
            return dateAttendance
          }
        )
      }
    },
    datesExamHospitalization: {
      get() {
        return Object.entries(this.getCombosResponse.Internacoes).map(
          ([key, value]) => {
            const dateHospitalization = {
              checkboxDesc: value,
              active: false
            }
            return dateHospitalization
          }
        )
      }
    },
    avisoComparecimento: {
      get() {
        let message = ''
        if (this.datesExamAttendance.length > 0) {
          message = this.$t('documentos.aviso-validacao-digital')
        } else {
          message = this.$t('documentos.aviso-comparecimento')
        }
        return message
      },
      set(newValue) {
        let finalMessage = newValue
        return finalMessage
      }
    },
    warningTextHosp: {
      get() {
        let message = ''
        if (this.datesExamHospitalization.length > 0) {
          message = this.$t('documentos.aviso-validacao-digital')
        } else {
          message = this.$t('documentos.aviso-internacao')
        }
        return message
      },
      set(newValue) {
        let finalMessage = newValue
        return finalMessage
      }
    }
  },
  methods: {
    ...mapActions([
      'getAtestadoFinalidades',
      'getCombosAction',
      'solicitarAtestadoCadeiraRodas',
      'solicitarSeloAcessibilidade',
      'solicitarFraldas',
      'solicitarAtestadoInternacoes',
      'solicitarAtestadoComparecimento',
      'solicitarDeclaracaoAtendimentos',
      'obterPdfAtestado'
    ]),
    ...mapMutations(['SET_ATESTADO_DADOS', 'DESABILITAR_BOTAO_ENVIAR']),
    stepsChange() {
      this.currentStep++
    },
    changeState() {
      this.statePage = !this.statePage
      this.showExamDate = !this.showExamDate
      this.statusOk = !this.statusOk
    },
    checkSelectedOption(obj) {
      this.valueSelected = obj.value
      this.finalidadeSelecionada = obj.id
    },
    async openDocs() {
      if (
        this.getRespostaAtestado.CodigoValidacao ||
        this.getRespostaAtestado.Codigo
      ) {
        const payload = {
          id: this.getRespostaAtestado.CodigoValidacao,
          code: this.getRespostaAtestado.Codigo,
          date: this.getRespostaAtestado.Data
        }
        let newWin = window.open()
        await this.obterPdfAtestado({ ...payload })
          .then(() => {
            const file = new Blob([this.getPatientPrintDocs], {
              type: 'application/pdf'
            })
            const fileURL = URL.createObjectURL(file)
            newWin.location.href = fileURL
          })
          .catch((err) => {
            throw err
          })
      } else {
        router.push('/documentos')
      }
    },
    async chooseSelected() {
      this.stepsChange()

      switch (this.finalidadeSelecionada) {
        case TiposAtestados.Comparecimento:
          let payload = {
            Comparecimentos: this.getDadosAtestado,
            Finalidade: TiposAtestados.Comparecimento,
            Tipo: TiposDocumentos.Atestado
          }
          await this.solicitarAtestadoComparecimento(payload)
            .then(() => {
              this.statePage = true
              this.stateTitle = this.getRespostaAtestado.Titulo
              this.stateText = this.getRespostaAtestado.Mensagem
              if (
                this.getRespostaAtestado.CodigoValidacao ||
                this.getRespostaAtestado.Codigo
              ) {
                this.buttonText = this.$t('botoes.visualizar')
              } else {
                this.buttonText = this.$t('botoes.confirmar')
              }
            })
            .catch(() => {
              this.statePage = true
              this.statusOk = false
            })
          break
        case TiposAtestados.Internacao:
          payload = {
            Internacoes: this.getDadosAtestado,
            Finalidade: TiposAtestados.Internacao,
            Tipo: TiposDocumentos.Atestado
          }
          await this.solicitarAtestadoInternacoes(payload)
            .then(() => {
              this.statePage = true
              this.stateTitle = this.getRespostaAtestado.Titulo
              this.stateText = this.getRespostaAtestado.Mensagem
              if (
                this.getRespostaAtestado.CodigoValidacao ||
                this.getRespostaAtestado.Codigo
              ) {
                this.buttonText = this.$t('botoes.visualizar')
              } else {
                this.buttonText = this.$t('botoes.confirmar')
              }
            })
            .catch(() => {
              this.statePage = true
              this.statusOk = false
            })
          break
        case TiposAtestados.CadeiraRodas:
          payload = {
            AutorizaCid: this.getDadosAtestado,
            Descricao: this.descricao,
            Finalidade: TiposAtestados.CadeiraRodas,
            Tipo: TiposDocumentos.Atestado
          }
          await this.solicitarAtestadoCadeiraRodas(payload)
            .then(() => {
              this.statePage = true
              this.stateTitle = this.getRespostaAtestado.Titulo
              this.stateText = this.getRespostaAtestado.Mensagem
              this.buttonText = this.$t('botoes.confirmar')
            })
            .catch((err) => {
              this.stateTitle = err.response.data.title
              this.stateText = err.response.data.detail
              this.statePage = true
              this.statusOk = false
            })
          break
        case TiposAtestados.Acessibilidade:
          payload = {
            AutorizaCid: this.getDadosAtestado,
            Descricao: this.descricao,
            Finalidade: TiposAtestados.Acessibilidade,
            Tipo: TiposDocumentos.Atestado
          }
          await this.solicitarSeloAcessibilidade(payload)
            .then(() => {
              this.statePage = true
              this.stateTitle = this.getRespostaAtestado.Titulo
              this.stateText = this.getRespostaAtestado.Mensagem
              this.buttonText = this.$t('botoes.confirmar')
            })
            .catch((err) => {
              this.stateTitle = err.response.data.title
              this.stateText = err.response.data.detail
              this.statePage = true
              this.statusOk = false
            })
          break
        case TiposAtestados.Fraldas:
          payload = {
            AutorizaCid: this.getDadosAtestado.cid,
            Descricao: this.descricao,
            DadosFralda: {
              Quantidade: 5,
              Tipo: this.getDadosAtestado.type,
              Tamanho: this.getDadosAtestado.size
            },
            Finalidade: TiposAtestados.Fraldas,
            Tipo: TiposDocumentos.Atestado
          }
          await this.solicitarFraldas(payload)
            .then(() => {
              this.statePage = true
              this.stateTitle = this.getRespostaAtestado.Titulo
              this.stateText = this.getRespostaAtestado.Mensagem
              this.buttonText = this.$t('botoes.confirmar')
            })
            .catch((err) => {
              this.stateTitle = err.response.data.title
              this.stateText = err.response.data.detail
              this.statePage = true
              this.statusOk = false
            })
          break
        case TiposAtestados.Declaracao:
          let params = {}

          if (this.getDateFilter.initDate && this.getDateFilter.endDate) {
            params = {
              Todos: false,
              DataInicio: this.getDateFilter.initDate,
              DataFim: this.getDateFilter.endDate,
              Finalidade: TiposAtestados.Declaracao,
              Tipo: TiposDocumentos.Atestado
            }
          } else {
            params = {
              Todos: true,
              DataInicio: null,
              DataFim: null,
              Finalidade: TiposAtestados.Declaracao,
              Tipo: TiposDocumentos.Atestado
            }
          }

          await this.solicitarDeclaracaoAtendimentos(params)
            .then(() => {
              this.statePage = true
              this.stateTitle = this.getRespostaAtestado.Titulo
              this.stateText = this.getRespostaAtestado.Mensagem
              if (
                this.getRespostaAtestado.CodigoValidacao ||
                this.getRespostaAtestado.Codigo
              ) {
                this.buttonText = this.$t('botoes.visualizar')
              } else {
                this.buttonText = this.$t('botoes.confirmar')
              }
            })
            .catch((err) => {
              this.stateTitle = err.response.data.title
              this.stateText = err.response.data.detail
              this.statePage = true
              this.statusOk = false
            })
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/warnings';
.issue-certificate {
  background-color: var(--gray-100);
  .container {
    height: 100%;
  }
  .general-forms {
    background-color: var(--bg-color-primary);
    margin-top: 1rem;
    min-height: 31.8125rem;
    height: 100%;
    padding: 1.5rem;
  }

  .textarea {
    max-width: 80%;
    min-width: 80%;
  }
  .warning {
    width: 80%;
    display: inline-table;
  }

  @media (max-width: $mobile-width-breakpoint) {
    .form-template {
      .select-form .dropdown .dropdown-trigger {
        width: 100%;
      }

      .select-date .info {
        width: 100%;
      }
    }
    .textarea {
      max-width: 100%;
    }
    .warning {
      max-width: 100%;
      width: 100%;
    }
  }
}
</style>
